import { render, staticRenderFns } from "./EditKnowledgeForm.vue?vue&type=template&id=6e9d97e0&scoped=true&"
import script from "./EditKnowledgeForm.vue?vue&type=script&lang=js&"
export * from "./EditKnowledgeForm.vue?vue&type=script&lang=js&"
import style0 from "./EditKnowledgeForm.vue?vue&type=style&index=0&id=6e9d97e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d97e0",
  null
  
)

export default component.exports